import React, { useState, useEffect } from 'react';
import { LogIn, LogOut, Save, Upload, Eye, EyeOff, CheckCircle, Home, Users, ShoppingBag, Award, Globe, Image, Trash2, Plus, MessageCircle, Loader, ChevronUp, ChevronDown, ArrowUp, ArrowDown } from 'lucide-react';
import { ref, onValue, set } from 'firebase/database';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { database, storage } from './firebase';

const BBAdminPanel = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [activeSection, setActiveSection] = useState('dashboard');
  const [saveStatus, setSaveStatus] = useState({ show: false, message: '' });
  const [uploading, setUploading] = useState(false);
  
  // CAPTCHA state
  const [captcha, setCaptcha] = useState({ num1: 0, num2: 0, answer: '' });
  const [captchaInput, setCaptchaInput] = useState('');

  // Generate new CAPTCHA
  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setCaptcha({ num1, num2, answer: String(num1 + num2) });
    setCaptchaInput('');
  };

  // Generate CAPTCHA on mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  const [siteData, setSiteData] = useState({
    logo: { url: 'https://i.ibb.co/p5FHHrc/IMG-7571.jpg' },
    socialLinks: {
      facebook: { url: 'https://www.facebook.com/bbbebeaute', customIcon: '' },
      tiktok: { url: 'https://www.tiktok.com/@bbbebeaute', customIcon: '' },
      shopee: { url: 'https://my.shp.ee/AtUcT6V', customIcon: '' },
      lazada: { url: 'https://s.lazada.com.my/s.unUaR', customIcon: '' },
      whatsapp: { url: 'https://wa.link/s8yuil', customIcon: '' }
    },
    languagePage: { subtitle_cn: '选择语言', subtitle_en: 'Choose Your Language' },
    genderPage: { title_cn: '请选择', title_en: 'Please Select', male_cn: '男士', male_en: 'Male', female_cn: '女士', female_en: 'Female' },
    popupMessages: {
      option1_cn: '如何证明你是女人？\n\n接下来的信息开玩笑的~\n以上回复纯属AI回复不代表本公司\n\n欢迎我们的可爱女人！💕',
      option1_en: 'How do you prove you\'re a woman?\n\nJust kidding~\nThe above reply is purely AI-generated and does not represent this company.\n\nWelcome, our lovely lady! 💕',
      option2_cn: '只有有缘人能发现此等宝物，你走运了！🍀✨',
      option2_en: 'Only the destined ones can discover such treasures. You\'re lucky! 🍀✨',
      option3_cn: '你是好女人还是坏女人？\n我只知道你是漂亮女人！😍\n\n(来自AI回复)',
      option3_en: 'Are you a good woman or a bad woman?\nI only know you\'re a beautiful woman! 😍\n\n(Reply from AI)',
      option4_cn: '你好，我们敬爱的用户！\n\n请支持我们的产品，不然这样按法公司服务器很快瘫痪，我跟老板都得去喝西北风了！😅\n\n(以上回复来自AI)',
      option4_en: 'Hello, our beloved user!\n\nPlease support our products, otherwise the server will crash from all this clicking, and the boss and I will have to go hungry! 😅\n\n(Reply from AI)',
      disclaimer_cn: '✨ 以上回复纯属AI娱乐，不代表本公司立场 ✨',
      disclaimer_en: '✨ The above is AI entertainment only, does not represent company views ✨',
      male_option1_cn: '欢迎帅哥！\n\n你来对地方了，让我们帮你成为更好的男人！💪\n\n(来自AI回复)',
      male_option1_en: 'Welcome handsome!\n\nYou\'ve come to the right place, let us help you become a better man! 💪\n\n(Reply from AI)',
      male_option2_cn: '真男人都懂得照顾自己！\n\n你已经迈出了第一步！🔥\n\n(来自AI回复)',
      male_option2_en: 'Real men know how to take care of themselves!\n\nYou\'ve taken the first step! 🔥\n\n(Reply from AI)',
      male_option3_cn: '帅哥，你是来找宝贝的吗？\n\n恭喜你找到了！✨\n\n(来自AI回复)',
      male_option3_en: 'Hey handsome, looking for treasures?\n\nCongratulations, you found it! ✨\n\n(Reply from AI)',
      male_option4_cn: '兄弟，你点太多次了！\n\n别玩了，快去看看我们的产品吧！😂\n\n(以上回复来自AI)',
      male_option4_en: 'Bro, you\'ve clicked too many times!\n\nStop playing around and check out our products! 😂\n\n(Reply from AI)',
      male_disclaimer_cn: '✨ 以上回复纯属AI娱乐，不代表本公司立场 ✨',
      male_disclaimer_en: '✨ The above is AI entertainment only, does not represent company views ✨'
    },
    menPage: {
      headline_cn: '提升生活质量，让女人对你念念不忘。',
      headline_en: 'Improve your quality of life, make women remember you.',
      subheadline_cn: '坏女人着迷，而你家女人自带飘逸因为实在太舒服',
      subheadline_en: 'Captivate women, bring satisfaction to your partner',
      product1_name_en: "MEN'S WASH",
      product1_subtitle_cn: '草本私密洁净露',
      productImages: [],
      packages: [
        { size: '200ml x1', price: 'RM 69.00', freeGift: '30ML x1', linkCn: 'https://wa.link/iwryvw', linkEn: 'https://wa.link/ibqohe' },
        { size: '200ml x2', price: 'RM 138.00', freeGift: '200ML x1', linkCn: 'https://wa.link/gul9qy', linkEn: 'https://wa.link/wkw01c' },
        { size: '30ml x1', price: 'RM 25.00', freeGift: '', linkCn: 'https://wa.link/s8yuil', linkEn: 'https://wa.link/s8yuil' }
      ],
      shipping: [
        { region_cn: '西马', region_en: 'West Malaysia', price: 'RM 5' },
        { region_cn: '东马', region_en: 'East Malaysia', price: 'RM 15' },
        { region_cn: '新加坡', region_en: 'Singapore', price: 'RM 25' }
      ]
    },
    womenPage: {
      headline_cn: '在你变得更美的同时气质的合金量也不断上升',
      headline_en: 'Become more beautiful while elevating your elegance',
      subheadline_cn: '让爱你的男人幸福，让渣男望尘莫及',
      subheadline_en: 'Bring happiness to those who love you, surpass all expectations',
      product1_name_en: 'FEMININE WASH',
      product1_name_cn: '草本私密洁净露',
      productImages: [
        'https://i.ibb.co/N2wJWwqd/1.jpg',
        'https://i.ibb.co/cSccCR7v/2.jpg'
      ],
      packages: [
        { size: '200ml x1', price: 'RM 69.00', freeGift: '30ML x1', linkCn: 'https://wa.link/iwryvw', linkEn: 'https://wa.link/ibqohe' },
        { size: '200ml x2', price: 'RM 138.00', freeGift: '200ML x1', linkCn: 'https://wa.link/gul9qy', linkEn: 'https://wa.link/wkw01c' },
        { size: '30ml x1', price: 'RM 25.00', freeGift: '', linkCn: 'https://wa.link/s8yuil', linkEn: 'https://wa.link/s8yuil' },
        { size: '', price: '', freeGift: '', linkCn: '', linkEn: '' }
      ],
      shipping: [
        { region_cn: '西马', region_en: 'West Malaysia', price: 'RM 5' },
        { region_cn: '东马', region_en: 'East Malaysia', price: 'RM 15' },
        { region_cn: '新加坡', region_en: 'Singapore', price: 'RM 25' }
      ]
    },
    productPage: {
      title_cn: '我们的产品', title_en: 'Our Products',
      certificates_title_cn: '相关文件', certificates_title_en: 'Company Documents',
      products: [
        { name_cn: '草本私密洁净露', name_en: 'Feminine Wash', price: 'RM 69.00', image: 'https://i.ibb.co/N2wJWwqd/1.jpg' },
        { name_cn: '产品特点', name_en: 'Product Features', price: '', image: 'https://i.ibb.co/cSccCR7v/2.jpg' }
      ],
      certificates: [
        { title_cn: '马来西亚卫生部认证', title_en: 'MOH Malaysia Notification', image: 'https://i.ibb.co/qL6rqyCh/IMG-7815.jpg' },
        { title_cn: '检验分析证书', title_en: 'Certificate of Analysis', image: 'https://i.ibb.co/mF4WC9LQ/IMG-7813.jpg' }
      ]
    },
    partnersPage: {
      title_cn: '我们的伙伴',
      title_en: 'Our Partners',
      subtitle_cn: '感谢以下伙伴的支持',
      subtitle_en: 'Thanks to our amazing partners',
      partners: []
    },
    whatsappNumber: '1234567890'
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Listen for real-time updates from Firebase
    const siteDataRef = ref(database, 'siteData');
    const unsubscribe = onValue(siteDataRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setSiteData(data);
      }
      setIsLoading(false);
    }, (error) => {
      console.error('Firebase read error:', error);
      setIsLoading(false);
    });

    if (sessionStorage.getItem('bbAdminLoggedIn') === 'true') setIsLoggedIn(true);

    return () => unsubscribe();
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    
    // Check CAPTCHA first
    if (captchaInput !== captcha.answer) {
      setLoginError('Incorrect CAPTCHA answer. Please try again.');
      generateCaptcha();
      return;
    }
    
    // Check credentials
    if (loginForm.username === 'bbadmin' && loginForm.password === 'beaute2024') {
      setIsLoggedIn(true);
      sessionStorage.setItem('bbAdminLoggedIn', 'true');
    } else {
      setLoginError('Invalid username or password');
      generateCaptcha();
    }
  };

  const saveData = async () => {
    try {
      const siteDataRef = ref(database, 'siteData');
      await set(siteDataRef, siteData);
      setSaveStatus({ show: true, message: 'Saved to Cloud! ☁️' });
      setTimeout(() => setSaveStatus({ show: false, message: '' }), 2000);
    } catch (error) {
      console.error('Firebase save error:', error);
      setSaveStatus({ show: true, message: 'Error saving!' });
      setTimeout(() => setSaveStatus({ show: false, message: '' }), 3000);
    }
  };

  // Firebase Storage Upload Function
  const uploadImage = async (file, folder = 'images') => {
    if (!file) return null;
    
    setUploading(true);
    try {
      const timestamp = Date.now();
      const fileName = `${folder}/${timestamp}_${file.name}`;
      const imageRef = storageRef(storage, fileName);
      
      await uploadBytes(imageRef, file);
      const downloadURL = await getDownloadURL(imageRef);
      
      setUploading(false);
      return downloadURL;
    } catch (error) {
      console.error('Upload error:', error);
      setUploading(false);
      alert('Upload failed: ' + error.message);
      return null;
    }
  };

  const css = {
    page: { minHeight: '100vh', fontFamily: 'system-ui, sans-serif' },
    loginBg: { background: 'linear-gradient(135deg, #9333ea, #ec4899)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
    card: { background: '#fff', borderRadius: 20, padding: 30, boxShadow: '0 10px 40px rgba(0,0,0,0.1)', marginBottom: 20 },
    input: { width: '100%', padding: 14, border: '2px solid #e5e5e5', borderRadius: 12, fontSize: 16, marginBottom: 15, boxSizing: 'border-box' },
    btn: { width: '100%', padding: 14, background: 'linear-gradient(135deg, #9333ea, #ec4899)', color: '#fff', border: 'none', borderRadius: 12, fontSize: 16, fontWeight: 600, cursor: 'pointer' },
    sidebar: { width: 250, background: '#fff', position: 'fixed', top: 0, bottom: 0, left: 0, boxShadow: '2px 0 20px rgba(0,0,0,0.08)', zIndex: 50, overflowY: 'auto' },
    menuItem: (active) => ({ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 20px', margin: '4px 12px', borderRadius: 12, border: 'none', width: 'calc(100% - 24px)', textAlign: 'left', cursor: 'pointer', background: active ? 'linear-gradient(135deg, #9333ea, #ec4899)' : 'transparent', color: active ? '#fff' : '#666', fontWeight: 500 }),
    main: { marginLeft: 250, padding: 30, background: '#f8f8f8', minHeight: '100vh' },
    title: { fontSize: 24, fontWeight: 700, marginBottom: 20, color: '#333' },
    label: { display: 'block', fontSize: 14, fontWeight: 600, marginBottom: 8, color: '#444' },
    field: { width: '100%', padding: 12, border: '2px solid #e5e5e5', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', marginBottom: 15 },
    toast: { position: 'fixed', top: 20, right: 20, background: '#22c55e', color: '#fff', padding: '12px 24px', borderRadius: 12, zIndex: 100, display: 'flex', alignItems: 'center', gap: 8 },
    imageCard: { border: '2px solid #e5e5e5', borderRadius: 12, padding: 15, marginBottom: 15, background: '#fafafa' },
    imagePreview: { width: '100%', maxWidth: 200, borderRadius: 10, marginTop: 10 },
    deleteBtn: { background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5 },
    addBtn: { background: '#e0f2fe', color: '#0284c7', border: 'none', borderRadius: 8, padding: '10px 20px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5, fontWeight: 600 },
    uploadBtn: { background: 'linear-gradient(135deg, #22c55e, #16a34a)', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5, fontWeight: 600 },
    uploadInput: { display: 'none' },
    orderBtn: { background: '#f3e8ff', color: '#9333ea', border: '1px solid #d8b4fe', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s' }
  };

  if (!isLoggedIn) {
    return (
      <div style={{ ...css.page, ...css.loginBg }}>
        <div style={{ ...css.card, maxWidth: 400, width: '100%' }}>
          <div style={{ textAlign: 'center', marginBottom: 30 }}>
            <div style={{ width: 70, height: 70, background: 'linear-gradient(135deg, #9333ea, #ec4899)', borderRadius: 16, margin: '0 auto 15px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 28, fontWeight: 700 }}>BB</div>
            <h1 style={{ margin: 0, fontSize: 24 }}>Admin Panel</h1>
            <p style={{ color: '#888', marginTop: 5 }}>Sign in to manage website</p>
          </div>
          {loginError && <div style={{ background: '#fee2e2', color: '#dc2626', padding: 12, borderRadius: 10, marginBottom: 15 }}>{loginError}</div>}
          <form onSubmit={handleLogin}>
            <label style={css.label}>Username</label>
            <input value={loginForm.username} onChange={e => setLoginForm({...loginForm, username: e.target.value})} style={css.input} placeholder="Enter username" />
            <label style={css.label}>Password</label>
            <div style={{ position: 'relative' }}>
              <input type={showPassword ? 'text' : 'password'} value={loginForm.password} onChange={e => setLoginForm({...loginForm, password: e.target.value})} style={css.input} placeholder="Enter password" />
              <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: 12, top: 12, background: 'none', border: 'none', cursor: 'pointer' }}>{showPassword ? <EyeOff size={20} color="#888" /> : <Eye size={20} color="#888" />}</button>
            </div>
            
            {/* CAPTCHA */}
            <label style={css.label}>Security Check</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 15 }}>
              <div style={{ 
                background: 'linear-gradient(135deg, #f3e8ff, #fce7f3)', 
                padding: '12px 20px', 
                borderRadius: 10, 
                fontSize: 20, 
                fontWeight: 700,
                color: '#9333ea',
                userSelect: 'none',
                letterSpacing: 2
              }}>
                {captcha.num1} + {captcha.num2} = ?
              </div>
              <button 
                type="button" 
                onClick={generateCaptcha}
                style={{ 
                  background: '#f3f4f6', 
                  border: 'none', 
                  borderRadius: 8, 
                  padding: '10px 12px', 
                  cursor: 'pointer',
                  fontSize: 16
                }}
                title="Get new question"
              >
                🔄
              </button>
            </div>
            <input 
              type="text" 
              value={captchaInput} 
              onChange={e => setCaptchaInput(e.target.value)} 
              style={css.input} 
              placeholder="Enter answer"
              required
            />
            
            <button type="submit" style={css.btn}><LogIn size={18} style={{ verticalAlign: 'middle', marginRight: 8 }} />Sign In</button>
          </form>
        </div>
      </div>
    );
  }

  const menuItems = [
    { id: 'dashboard', icon: Home, label: 'Dashboard' },
    { id: 'social', icon: Globe, label: 'Social Links' },
    { id: 'logo', icon: Image, label: 'Logo' },
    { id: 'popup', icon: MessageCircle, label: 'Popup Messages' },
    { id: 'men', icon: Users, label: "Men's Page" },
    { id: 'women', icon: Users, label: "Women's Page" },
    { id: 'products', icon: ShoppingBag, label: 'Products Page' },
    { id: 'partners', icon: Users, label: 'Partners 伙伴' },
    { id: 'certificates', icon: Award, label: 'Documents 相关文件' }
  ];

  const Field = ({ label, value, onChange, area }) => (
    <div>
      <label style={css.label}>{label}</label>
      {area ? <textarea value={value || ''} onChange={e => onChange(e.target.value)} style={{ ...css.field, minHeight: 80 }} /> : <input value={value || ''} onChange={e => onChange(e.target.value)} style={css.field} />}
    </div>
  );

  // Helper function to update popup messages without losing focus
  const updatePopupMessage = (key, value) => {
    setSiteData(prev => ({
      ...prev,
      popupMessages: {
        ...prev.popupMessages,
        [key]: value
      }
    }));
  };

  // Image Upload Component with Firebase Storage
  const ImageUploader = ({ currentUrl, onUpload, folder, label }) => {
    const inputId = `upload-${folder}-${Date.now()}`;
    
    const handleFileChange = async (e) => {
      const file = e.target.files[0];
      if (file) {
        const url = await uploadImage(file, folder);
        if (url) {
          onUpload(url);
        }
      }
    };

    return (
      <div>
        <label style={css.label}>{label || 'Image 图片'}</label>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 10 }}>
          <input
            type="file"
            id={inputId}
            accept="image/*"
            onChange={handleFileChange}
            style={css.uploadInput}
          />
          <label htmlFor={inputId} style={{ ...css.uploadBtn, cursor: uploading ? 'not-allowed' : 'pointer', opacity: uploading ? 0.7 : 1 }}>
            {uploading ? <Loader size={18} className="spin" /> : <Upload size={18} />}
            {uploading ? 'Uploading...' : 'Upload Image 上传图片'}
          </label>
        </div>
        {currentUrl && (
          <img src={currentUrl} alt="Preview" style={{ maxWidth: 200, borderRadius: 10, marginTop: 10, border: '2px solid #e5e5e5' }} />
        )}
      </div>
    );
  };

  // Image Manager with Drag & Drop reordering
  const ImageManager = ({ images, onUpdate, color, folder, label }) => {
    const inputId = `upload-multi-${folder}-${Date.now()}-${Math.random()}`;
    const [draggedIdx, setDraggedIdx] = useState(null);
    const [dragOverIdx, setDragOverIdx] = useState(null);
    
    const handleFileChange = async (e) => {
      const file = e.target.files[0];
      if (file) {
        const url = await uploadImage(file, folder);
        if (url) {
          onUpdate([...(images || []), url]);
        }
      }
      e.target.value = '';
    };
    
    const removeImage = (idx) => {
      onUpdate((images || []).filter((_, i) => i !== idx));
    };

    // Drag handlers
    const handleDragStart = (e, idx) => {
      setDraggedIdx(idx);
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/html', e.target.innerHTML);
    };

    const handleDragOver = (e, idx) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      setDragOverIdx(idx);
    };

    const handleDragLeave = () => {
      setDragOverIdx(null);
    };

    const handleDrop = (e, dropIdx) => {
      e.preventDefault();
      if (draggedIdx === null || draggedIdx === dropIdx) {
        setDraggedIdx(null);
        setDragOverIdx(null);
        return;
      }
      
      const newImages = [...(images || [])];
      const [draggedItem] = newImages.splice(draggedIdx, 1);
      newImages.splice(dropIdx, 0, draggedItem);
      onUpdate(newImages);
      
      setDraggedIdx(null);
      setDragOverIdx(null);
    };

    const handleDragEnd = () => {
      setDraggedIdx(null);
      setDragOverIdx(null);
    };

    return (
      <div>
        <label style={css.label}>{label || 'Product Images 产品图片'}</label>
        <p style={{ fontSize: 12, color: '#666', margin: '0 0 10px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ background: '#f3e8ff', padding: '4px 8px', borderRadius: 6, color: '#9333ea', fontWeight: 600 }}>✋ Drag to reorder 拖动排序</span>
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 15, marginBottom: 15 }}>
          {images && images.map((img, idx) => (
            <div 
              key={idx} 
              draggable
              onDragStart={(e) => handleDragStart(e, idx)}
              onDragOver={(e) => handleDragOver(e, idx)}
              onDragLeave={handleDragLeave}
              onDrop={(e) => handleDrop(e, idx)}
              onDragEnd={handleDragEnd}
              style={{ 
                ...css.imageCard, 
                position: 'relative',
                cursor: 'grab',
                opacity: draggedIdx === idx ? 0.5 : 1,
                transform: dragOverIdx === idx && draggedIdx !== idx ? 'scale(1.02)' : 'scale(1)',
                border: dragOverIdx === idx && draggedIdx !== idx ? '3px dashed #9333ea' : '2px solid #e5e5e5',
                transition: 'transform 0.2s, border 0.2s, opacity 0.2s'
              }}
            >
              {/* Position Badge */}
              <div style={{ 
                position: 'absolute', 
                top: 8, 
                left: 8, 
                background: '#9333ea', 
                color: '#fff', 
                borderRadius: '50%', 
                width: 32, 
                height: 32, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                fontWeight: 'bold',
                fontSize: 16,
                zIndex: 10,
                boxShadow: '0 2px 8px rgba(147, 51, 234, 0.4)'
              }}>
                {idx + 1}
              </div>
              
              {/* Drag Handle Icon */}
              <div style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: 'rgba(255,255,255,0.9)',
                borderRadius: 6,
                padding: '4px 8px',
                fontSize: 12,
                color: '#666',
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                zIndex: 10
              }}>
                <span style={{ fontSize: 16 }}>⠿</span> Drag
              </div>
              
              <img 
                src={img} 
                alt={`Product ${idx + 1}`} 
                style={{ width: '100%', borderRadius: 8, pointerEvents: 'none' }} 
                draggable={false}
              />
              
              <button 
                onClick={() => removeImage(idx)} 
                style={{ ...css.deleteBtn, marginTop: 10, width: '100%', justifyContent: 'center' }}
              >
                <Trash2 size={16} /> Remove 删除
              </button>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <input
            type="file"
            id={inputId}
            accept="image/*"
            onChange={handleFileChange}
            style={css.uploadInput}
          />
          <label htmlFor={inputId} style={{ ...css.uploadBtn, cursor: uploading ? 'not-allowed' : 'pointer', opacity: uploading ? 0.7 : 1 }}>
            {uploading ? <Loader size={18} /> : <Upload size={18} />}
            {uploading ? 'Uploading...' : 'Upload 上传'}
          </label>
        </div>
      </div>
    );
  };

  const renderSection = () => {
    switch(activeSection) {
      case 'dashboard':
        return (
          <div>
            <h2 style={css.title}>Dashboard</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 20 }}>
              <div style={{ background: 'linear-gradient(135deg, #9333ea, #7c3aed)', borderRadius: 16, padding: 25, color: '#fff' }}><Globe size={32} /><h3 style={{ marginTop: 10 }}>Social Links</h3></div>
              <div style={{ background: 'linear-gradient(135deg, #0ea5e9, #06b6d4)', borderRadius: 16, padding: 25, color: '#fff' }}><Users size={32} /><h3 style={{ marginTop: 10 }}>Men's Page</h3></div>
              <div style={{ background: 'linear-gradient(135deg, #ec4899, #f43f5e)', borderRadius: 16, padding: 25, color: '#fff' }}><Users size={32} /><h3 style={{ marginTop: 10 }}>Women's Page</h3></div>
              <div style={{ background: 'linear-gradient(135deg, #22c55e, #16a34a)', borderRadius: 16, padding: 25, color: '#fff' }}><ShoppingBag size={32} /><h3 style={{ marginTop: 10 }}>Products</h3></div>
            </div>
            <div style={{ marginTop: 30, background: '#d1fae5', border: '1px solid #6ee7b7', borderRadius: 12, padding: 20 }}>
              <h4 style={{ margin: '0 0 10px', color: '#065f46' }}>🎉 Direct Image Upload Enabled!</h4>
              <p style={{ margin: 0, color: '#047857', fontSize: 14 }}>
                You can now upload images directly in the admin panel. No need to use imgbb.com anymore!
                <br />Images are stored in Firebase Storage.
              </p>
            </div>
          </div>
        );
      case 'social':
        return (
          <div>
            <h2 style={css.title}>Social Links</h2>
            <div style={css.card}>
              {['facebook', 'tiktok', 'shopee', 'lazada', 'whatsapp'].map(p => (
                <div key={p} style={{ marginBottom: 20 }}>
                  <label style={css.label}>{p.charAt(0).toUpperCase() + p.slice(1)} URL</label>
                  <input value={siteData.socialLinks[p]?.url || ''} onChange={e => setSiteData({...siteData, socialLinks: {...siteData.socialLinks, [p]: {...siteData.socialLinks[p], url: e.target.value}}})} placeholder={`https://${p}.com/yourpage`} style={css.field} />
                </div>
              ))}
            </div>
          </div>
        );
      case 'logo':
        return (
          <div>
            <h2 style={css.title}>Logo</h2>
            <div style={css.card}>
              <ImageUploader
                currentUrl={siteData.logo.url}
                onUpload={(url) => setSiteData({...siteData, logo: { url }})}
                folder="logo"
                label="Logo Image 标志图片"
              />
              <div style={{ marginTop: 20 }}>
                <label style={css.label}>Or paste URL 或粘贴链接</label>
                <input 
                  value={siteData.logo.url} 
                  onChange={e => setSiteData({...siteData, logo: { url: e.target.value }})} 
                  style={css.field}
                  placeholder="https://..."
                />
              </div>
            </div>
          </div>
        );
      case 'popup':
        return (
          <div>
            <h2 style={css.title}>AI Popup Messages 弹窗消息</h2>
            <p style={{ color: '#666', marginBottom: 20 }}>Every click shows a random popup (Option 1, 2, or 3). Each time shows a different option. If clicked 4 times in 1 minute, shows Option 4 (spam warning).</p>
            
            <h3 style={{ color: '#db2777', marginTop: 30, marginBottom: 15 }}>💕 Female 女士 Popup Messages</h3>
            
            <div style={css.card}>
              <h4 style={{ marginTop: 0, color: '#db2777' }}>Option 1 选项一</h4>
              <div>
                <label style={css.label}>Chinese 中文</label>
                <textarea 
                  value={siteData.popupMessages?.option1_cn || ''} 
                  onChange={e => updatePopupMessage('option1_cn', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
              <div>
                <label style={css.label}>English 英文</label>
                <textarea 
                  value={siteData.popupMessages?.option1_en || ''} 
                  onChange={e => updatePopupMessage('option1_en', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
            </div>
            
            <div style={css.card}>
              <h4 style={{ marginTop: 0, color: '#db2777' }}>Option 2 选项二</h4>
              <div>
                <label style={css.label}>Chinese 中文</label>
                <textarea 
                  value={siteData.popupMessages?.option2_cn || ''} 
                  onChange={e => updatePopupMessage('option2_cn', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
              <div>
                <label style={css.label}>English 英文</label>
                <textarea 
                  value={siteData.popupMessages?.option2_en || ''} 
                  onChange={e => updatePopupMessage('option2_en', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
            </div>
            
            <div style={css.card}>
              <h4 style={{ marginTop: 0, color: '#db2777' }}>Option 3 选项三</h4>
              <div>
                <label style={css.label}>Chinese 中文</label>
                <textarea 
                  value={siteData.popupMessages?.option3_cn || ''} 
                  onChange={e => updatePopupMessage('option3_cn', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
              <div>
                <label style={css.label}>English 英文</label>
                <textarea 
                  value={siteData.popupMessages?.option3_en || ''} 
                  onChange={e => updatePopupMessage('option3_en', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
            </div>
            
            <div style={{ ...css.card, background: '#fef2f2', border: '1px solid #fecaca' }}>
              <h4 style={{ marginTop: 0, color: '#dc2626' }}>Option 4 选项四 (Spam Warning 疯狂点击警告)</h4>
              <p style={{ color: '#666', fontSize: 14 }}>Shows when user clicks 4 times in 1 minute</p>
              <div>
                <label style={css.label}>Chinese 中文</label>
                <textarea 
                  value={siteData.popupMessages?.option4_cn || ''} 
                  onChange={e => updatePopupMessage('option4_cn', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
              <div>
                <label style={css.label}>English 英文</label>
                <textarea 
                  value={siteData.popupMessages?.option4_en || ''} 
                  onChange={e => updatePopupMessage('option4_en', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
            </div>
            
            <div style={css.card}>
              <h4 style={{ marginTop: 0, color: '#db2777' }}>Female Disclaimer 女士免责声明</h4>
              <div>
                <label style={css.label}>Chinese 中文</label>
                <input 
                  value={siteData.popupMessages?.disclaimer_cn || ''} 
                  onChange={e => updatePopupMessage('disclaimer_cn', e.target.value)} 
                  style={css.field} 
                />
              </div>
              <div>
                <label style={css.label}>English 英文</label>
                <input 
                  value={siteData.popupMessages?.disclaimer_en || ''} 
                  onChange={e => updatePopupMessage('disclaimer_en', e.target.value)} 
                  style={css.field} 
                />
              </div>
            </div>
            
            <h3 style={{ color: '#0284c7', marginTop: 40, marginBottom: 15 }}>💪 Male 男士 Popup Messages</h3>
            
            <div style={{ ...css.card, background: '#f0f9ff', border: '1px solid #bae6fd' }}>
              <h4 style={{ marginTop: 0, color: '#0284c7' }}>Option 1 选项一</h4>
              <div>
                <label style={css.label}>Chinese 中文</label>
                <textarea 
                  value={siteData.popupMessages?.male_option1_cn || ''} 
                  onChange={e => updatePopupMessage('male_option1_cn', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
              <div>
                <label style={css.label}>English 英文</label>
                <textarea 
                  value={siteData.popupMessages?.male_option1_en || ''} 
                  onChange={e => updatePopupMessage('male_option1_en', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
            </div>
            
            <div style={{ ...css.card, background: '#f0f9ff', border: '1px solid #bae6fd' }}>
              <h4 style={{ marginTop: 0, color: '#0284c7' }}>Option 2 选项二</h4>
              <div>
                <label style={css.label}>Chinese 中文</label>
                <textarea 
                  value={siteData.popupMessages?.male_option2_cn || ''} 
                  onChange={e => updatePopupMessage('male_option2_cn', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
              <div>
                <label style={css.label}>English 英文</label>
                <textarea 
                  value={siteData.popupMessages?.male_option2_en || ''} 
                  onChange={e => updatePopupMessage('male_option2_en', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
            </div>
            
            <div style={{ ...css.card, background: '#f0f9ff', border: '1px solid #bae6fd' }}>
              <h4 style={{ marginTop: 0, color: '#0284c7' }}>Option 3 选项三</h4>
              <div>
                <label style={css.label}>Chinese 中文</label>
                <textarea 
                  value={siteData.popupMessages?.male_option3_cn || ''} 
                  onChange={e => updatePopupMessage('male_option3_cn', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
              <div>
                <label style={css.label}>English 英文</label>
                <textarea 
                  value={siteData.popupMessages?.male_option3_en || ''} 
                  onChange={e => updatePopupMessage('male_option3_en', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
            </div>
            
            <div style={{ ...css.card, background: '#eff6ff', border: '1px solid #93c5fd' }}>
              <h4 style={{ marginTop: 0, color: '#1d4ed8' }}>Option 4 选项四 (Spam Warning 疯狂点击警告)</h4>
              <p style={{ color: '#666', fontSize: 14 }}>Shows when user clicks 4 times in 1 minute</p>
              <div>
                <label style={css.label}>Chinese 中文</label>
                <textarea 
                  value={siteData.popupMessages?.male_option4_cn || ''} 
                  onChange={e => updatePopupMessage('male_option4_cn', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
              <div>
                <label style={css.label}>English 英文</label>
                <textarea 
                  value={siteData.popupMessages?.male_option4_en || ''} 
                  onChange={e => updatePopupMessage('male_option4_en', e.target.value)} 
                  style={{ ...css.field, minHeight: 80 }} 
                />
              </div>
            </div>
            
            <div style={css.card}>
              <h4 style={{ marginTop: 0, color: '#0284c7' }}>Male Disclaimer 男士免责声明</h4>
              <div>
                <label style={css.label}>Chinese 中文</label>
                <input 
                  value={siteData.popupMessages?.male_disclaimer_cn || ''} 
                  onChange={e => updatePopupMessage('male_disclaimer_cn', e.target.value)} 
                  style={css.field} 
                />
              </div>
              <div>
                <label style={css.label}>English 英文</label>
                <input 
                  value={siteData.popupMessages?.male_disclaimer_en || ''} 
                  onChange={e => updatePopupMessage('male_disclaimer_en', e.target.value)} 
                  style={css.field} 
                />
              </div>
            </div>
          </div>
        );
      case 'men':
        return (
          <div>
            <h2 style={css.title}>Men's Page 男士页面</h2>
            <div style={css.card}>
              <Field label="Headline (Chinese) 标题" value={siteData.menPage.headline_cn} onChange={v => setSiteData({...siteData, menPage: {...siteData.menPage, headline_cn: v}})} />
              <Field label="Headline (English)" value={siteData.menPage.headline_en} onChange={v => setSiteData({...siteData, menPage: {...siteData.menPage, headline_en: v}})} />
              <Field label="Subheadline (Chinese) 副标题" value={siteData.menPage.subheadline_cn} onChange={v => setSiteData({...siteData, menPage: {...siteData.menPage, subheadline_cn: v}})} area />
              <Field label="Product Name 产品名称" value={siteData.menPage.product1_name_en} onChange={v => setSiteData({...siteData, menPage: {...siteData.menPage, product1_name_en: v}})} />
              <Field label="Product Subtitle (Chinese)" value={siteData.menPage.product1_subtitle_cn} onChange={v => setSiteData({...siteData, menPage: {...siteData.menPage, product1_subtitle_cn: v}})} />
            </div>
            
            {/* Product Images - Chinese */}
            <div style={{ ...css.card, background: '#fef3c7', border: '1px solid #fcd34d' }}>
              <h4 style={{ marginTop: 0, color: '#92400e' }}>🇨🇳 Product Images (Chinese) 产品图片（中文）</h4>
              <ImageManager 
                images={siteData.menPage.productImages || []} 
                onUpdate={(imgs) => setSiteData({...siteData, menPage: {...siteData.menPage, productImages: imgs}})}
                color="#e0f2fe"
                folder="men-products-cn"
                label="Images for Chinese version 中文版图片"
              />
            </div>
            
            {/* Product Images - English */}
            <div style={{ ...css.card, background: '#dbeafe', border: '1px solid #93c5fd' }}>
              <h4 style={{ marginTop: 0, color: '#1d4ed8' }}>🇬🇧 Product Images (English) 产品图片（英文）</h4>
              <ImageManager 
                images={siteData.menPage.productImagesEn || []} 
                onUpdate={(imgs) => setSiteData({...siteData, menPage: {...siteData.menPage, productImagesEn: imgs}})}
                color="#dbeafe"
                folder="men-products-en"
                label="Images for English version 英文版图片"
              />
            </div>
            
            <div style={css.card}>
              <label style={css.label}>Packages 配套</label>
              {(siteData.menPage.packages || []).map((pkg, idx) => (
                <div key={idx} style={{ marginBottom: 15, padding: 15, background: '#f0f9ff', borderRadius: 10 }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>
                    <input value={pkg.size || ''} onChange={e => {
                      const pkgs = [...(siteData.menPage.packages || [])];
                      pkgs[idx] = {...pkgs[idx], size: e.target.value};
                      setSiteData({...siteData, menPage: {...siteData.menPage, packages: pkgs}});
                    }} placeholder="Size 规格" style={{ ...css.field, marginBottom: 0 }} />
                    <input value={pkg.price || ''} onChange={e => {
                      const pkgs = [...(siteData.menPage.packages || [])];
                      pkgs[idx] = {...pkgs[idx], price: e.target.value};
                      setSiteData({...siteData, menPage: {...siteData.menPage, packages: pkgs}});
                    }} placeholder="Price 价格" style={{ ...css.field, marginBottom: 0 }} />
                    <input value={pkg.freeGift || ''} onChange={e => {
                      const pkgs = [...(siteData.menPage.packages || [])];
                      pkgs[idx] = {...pkgs[idx], freeGift: e.target.value};
                      setSiteData({...siteData, menPage: {...siteData.menPage, packages: pkgs}});
                    }} placeholder="Free Gift 赠品" style={{ ...css.field, marginBottom: 0 }} />
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                    <input value={pkg.linkCn || ''} onChange={e => {
                      const pkgs = [...(siteData.menPage.packages || [])];
                      pkgs[idx] = {...pkgs[idx], linkCn: e.target.value};
                      setSiteData({...siteData, menPage: {...siteData.menPage, packages: pkgs}});
                    }} placeholder="WhatsApp Link (Chinese) 中文链接" style={{ ...css.field, marginBottom: 0 }} />
                    <input value={pkg.linkEn || ''} onChange={e => {
                      const pkgs = [...(siteData.menPage.packages || [])];
                      pkgs[idx] = {...pkgs[idx], linkEn: e.target.value};
                      setSiteData({...siteData, menPage: {...siteData.menPage, packages: pkgs}});
                    }} placeholder="WhatsApp Link (English) 英文链接" style={{ ...css.field, marginBottom: 0 }} />
                  </div>
                  <button 
                    onClick={() => {
                      const pkgs = (siteData.menPage.packages || []).filter((_, i) => i !== idx);
                      setSiteData({...siteData, menPage: {...siteData.menPage, packages: pkgs}});
                    }}
                    style={{ ...css.deleteBtn, marginTop: 10 }}
                  >
                    <Trash2 size={16} /> Delete Package 删除配套
                  </button>
                </div>
              ))}
              <button 
                onClick={() => {
                  const newPkg = { size: '', price: '', freeGift: '', linkCn: '', linkEn: '' };
                  setSiteData({...siteData, menPage: {...siteData.menPage, packages: [...(siteData.menPage.packages || []), newPkg]}});
                }}
                style={css.addBtn}
              >
                <Plus size={18} /> Add Package 添加配套
              </button>
            </div>
            
            {/* Shipping Fees Section */}
            <div style={css.card}>
              <label style={css.label}>Shipping Fees 运费说明</label>
              {(siteData.menPage.shipping || []).map((ship, idx) => (
                <div key={idx} style={{ marginBottom: 15, padding: 15, background: '#ecfdf5', borderRadius: 10, border: '1px solid #a7f3d0' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>
                    <input value={ship.region_cn || ''} onChange={e => {
                      const ships = [...(siteData.menPage.shipping || [])];
                      ships[idx] = {...ships[idx], region_cn: e.target.value};
                      setSiteData({...siteData, menPage: {...siteData.menPage, shipping: ships}});
                    }} placeholder="Region (Chinese) 地区中文" style={{ ...css.field, marginBottom: 0 }} />
                    <input value={ship.region_en || ''} onChange={e => {
                      const ships = [...(siteData.menPage.shipping || [])];
                      ships[idx] = {...ships[idx], region_en: e.target.value};
                      setSiteData({...siteData, menPage: {...siteData.menPage, shipping: ships}});
                    }} placeholder="Region (English) 地区英文" style={{ ...css.field, marginBottom: 0 }} />
                    <input value={ship.price || ''} onChange={e => {
                      const ships = [...(siteData.menPage.shipping || [])];
                      ships[idx] = {...ships[idx], price: e.target.value};
                      setSiteData({...siteData, menPage: {...siteData.menPage, shipping: ships}});
                    }} placeholder="Price 运费 (e.g. RM 5)" style={{ ...css.field, marginBottom: 0 }} />
                  </div>
                  <button 
                    onClick={() => {
                      const ships = (siteData.menPage.shipping || []).filter((_, i) => i !== idx);
                      setSiteData({...siteData, menPage: {...siteData.menPage, shipping: ships}});
                    }}
                    style={css.deleteBtn}
                  >
                    <Trash2 size={16} /> Delete 删除
                  </button>
                </div>
              ))}
              <button 
                onClick={() => {
                  const newShip = { region_cn: '', region_en: '', price: '' };
                  setSiteData({...siteData, menPage: {...siteData.menPage, shipping: [...(siteData.menPage.shipping || []), newShip]}});
                }}
                style={{ ...css.addBtn, background: 'linear-gradient(135deg, #22c55e, #16a34a)', color: '#fff' }}
              >
                <Plus size={18} /> Add Shipping Region 添加运费地区
              </button>
            </div>
          </div>
        );
      case 'women':
        return (
          <div>
            <h2 style={css.title}>Women's Page 女士页面</h2>
            <div style={css.card}>
              <Field label="Headline (Chinese) 标题" value={siteData.womenPage.headline_cn} onChange={v => setSiteData({...siteData, womenPage: {...siteData.womenPage, headline_cn: v}})} />
              <Field label="Headline (English)" value={siteData.womenPage.headline_en} onChange={v => setSiteData({...siteData, womenPage: {...siteData.womenPage, headline_en: v}})} />
              <Field label="Subheadline (Chinese) 副标题" value={siteData.womenPage.subheadline_cn} onChange={v => setSiteData({...siteData, womenPage: {...siteData.womenPage, subheadline_cn: v}})} area />
              <Field label="Product Name 产品名称" value={siteData.womenPage.product1_name_en} onChange={v => setSiteData({...siteData, womenPage: {...siteData.womenPage, product1_name_en: v}})} />
              <Field label="Product Subtitle (Chinese)" value={siteData.womenPage.product1_name_cn} onChange={v => setSiteData({...siteData, womenPage: {...siteData.womenPage, product1_name_cn: v}})} />
            </div>
            
            {/* Product Images - Chinese */}
            <div style={{ ...css.card, background: '#fef3c7', border: '1px solid #fcd34d' }}>
              <h4 style={{ marginTop: 0, color: '#92400e' }}>🇨🇳 Product Images (Chinese) 产品图片（中文）</h4>
              <ImageManager 
                images={siteData.womenPage.productImages || []} 
                onUpdate={(imgs) => setSiteData({...siteData, womenPage: {...siteData.womenPage, productImages: imgs}})}
                color="#fce7f3"
                folder="women-products-cn"
                label="Images for Chinese version 中文版图片"
              />
            </div>
            
            {/* Product Images - English */}
            <div style={{ ...css.card, background: '#dbeafe', border: '1px solid #93c5fd' }}>
              <h4 style={{ marginTop: 0, color: '#1d4ed8' }}>🇬🇧 Product Images (English) 产品图片（英文）</h4>
              <ImageManager 
                images={siteData.womenPage.productImagesEn || []} 
                onUpdate={(imgs) => setSiteData({...siteData, womenPage: {...siteData.womenPage, productImagesEn: imgs}})}
                color="#dbeafe"
                folder="women-products-en"
                label="Images for English version 英文版图片"
              />
            </div>
            
            <div style={css.card}>
              <label style={css.label}>Packages 配套</label>
              {(siteData.womenPage.packages || []).map((pkg, idx) => (
                <div key={idx} style={{ marginBottom: 15, padding: 15, background: '#fdf2f8', borderRadius: 10 }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>
                    <input value={pkg.size || ''} onChange={e => {
                      const pkgs = [...(siteData.womenPage.packages || [])];
                      pkgs[idx] = {...pkgs[idx], size: e.target.value};
                      setSiteData({...siteData, womenPage: {...siteData.womenPage, packages: pkgs}});
                    }} placeholder="Size 规格" style={{ ...css.field, marginBottom: 0 }} />
                    <input value={pkg.price || ''} onChange={e => {
                      const pkgs = [...(siteData.womenPage.packages || [])];
                      pkgs[idx] = {...pkgs[idx], price: e.target.value};
                      setSiteData({...siteData, womenPage: {...siteData.womenPage, packages: pkgs}});
                    }} placeholder="Price 价格" style={{ ...css.field, marginBottom: 0 }} />
                    <input value={pkg.freeGift || ''} onChange={e => {
                      const pkgs = [...(siteData.womenPage.packages || [])];
                      pkgs[idx] = {...pkgs[idx], freeGift: e.target.value};
                      setSiteData({...siteData, womenPage: {...siteData.womenPage, packages: pkgs}});
                    }} placeholder="Free Gift 赠品" style={{ ...css.field, marginBottom: 0 }} />
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                    <input value={pkg.linkCn || ''} onChange={e => {
                      const pkgs = [...(siteData.womenPage.packages || [])];
                      pkgs[idx] = {...pkgs[idx], linkCn: e.target.value};
                      setSiteData({...siteData, womenPage: {...siteData.womenPage, packages: pkgs}});
                    }} placeholder="WhatsApp Link (Chinese) 中文链接" style={{ ...css.field, marginBottom: 0 }} />
                    <input value={pkg.linkEn || ''} onChange={e => {
                      const pkgs = [...(siteData.womenPage.packages || [])];
                      pkgs[idx] = {...pkgs[idx], linkEn: e.target.value};
                      setSiteData({...siteData, womenPage: {...siteData.womenPage, packages: pkgs}});
                    }} placeholder="WhatsApp Link (English) 英文链接" style={{ ...css.field, marginBottom: 0 }} />
                  </div>
                  <button 
                    onClick={() => {
                      const pkgs = (siteData.womenPage.packages || []).filter((_, i) => i !== idx);
                      setSiteData({...siteData, womenPage: {...siteData.womenPage, packages: pkgs}});
                    }}
                    style={{ ...css.deleteBtn, marginTop: 10 }}
                  >
                    <Trash2 size={16} /> Delete Package 删除配套
                  </button>
                </div>
              ))}
              <button 
                onClick={() => {
                  const newPkg = { size: '', price: '', freeGift: '', linkCn: '', linkEn: '' };
                  setSiteData({...siteData, womenPage: {...siteData.womenPage, packages: [...(siteData.womenPage.packages || []), newPkg]}});
                }}
                style={{ ...css.addBtn, background: 'linear-gradient(135deg, #ec4899, #f43f5e)', color: '#fff' }}
              >
                <Plus size={18} /> Add Package 添加配套
              </button>
            </div>
            
            {/* Shipping Fees Section */}
            <div style={css.card}>
              <label style={css.label}>Shipping Fees 运费说明</label>
              {(siteData.womenPage.shipping || []).map((ship, idx) => (
                <div key={idx} style={{ marginBottom: 15, padding: 15, background: '#fdf2f8', borderRadius: 10, border: '1px solid #fbcfe8' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>
                    <input value={ship.region_cn || ''} onChange={e => {
                      const ships = [...(siteData.womenPage.shipping || [])];
                      ships[idx] = {...ships[idx], region_cn: e.target.value};
                      setSiteData({...siteData, womenPage: {...siteData.womenPage, shipping: ships}});
                    }} placeholder="Region (Chinese) 地区中文" style={{ ...css.field, marginBottom: 0 }} />
                    <input value={ship.region_en || ''} onChange={e => {
                      const ships = [...(siteData.womenPage.shipping || [])];
                      ships[idx] = {...ships[idx], region_en: e.target.value};
                      setSiteData({...siteData, womenPage: {...siteData.womenPage, shipping: ships}});
                    }} placeholder="Region (English) 地区英文" style={{ ...css.field, marginBottom: 0 }} />
                    <input value={ship.price || ''} onChange={e => {
                      const ships = [...(siteData.womenPage.shipping || [])];
                      ships[idx] = {...ships[idx], price: e.target.value};
                      setSiteData({...siteData, womenPage: {...siteData.womenPage, shipping: ships}});
                    }} placeholder="Price 运费 (e.g. RM 5)" style={{ ...css.field, marginBottom: 0 }} />
                  </div>
                  <button 
                    onClick={() => {
                      const ships = (siteData.womenPage.shipping || []).filter((_, i) => i !== idx);
                      setSiteData({...siteData, womenPage: {...siteData.womenPage, shipping: ships}});
                    }}
                    style={css.deleteBtn}
                  >
                    <Trash2 size={16} /> Delete 删除
                  </button>
                </div>
              ))}
              <button 
                onClick={() => {
                  const newShip = { region_cn: '', region_en: '', price: '' };
                  setSiteData({...siteData, womenPage: {...siteData.womenPage, shipping: [...(siteData.womenPage.shipping || []), newShip]}});
                }}
                style={{ ...css.addBtn, background: 'linear-gradient(135deg, #ec4899, #f43f5e)', color: '#fff' }}
              >
                <Plus size={18} /> Add Shipping Region 添加运费地区
              </button>
            </div>
          </div>
        );
      case 'products':
        return (
          <div>
            <h2 style={css.title}>Products Page 产品页面</h2>
            <div style={css.card}>
              <Field label="Page Title (Chinese)" value={siteData.productPage.title_cn} onChange={v => setSiteData({...siteData, productPage: {...siteData.productPage, title_cn: v}})} />
              <Field label="Page Title (English)" value={siteData.productPage.title_en} onChange={v => setSiteData({...siteData, productPage: {...siteData.productPage, title_en: v}})} />
            </div>
            {siteData.productPage.products.map((prod, idx) => (
              <div key={idx} style={css.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h4 style={{ marginTop: 0 }}>Product {idx + 1}</h4>
                  {siteData.productPage.products.length > 1 && (
                    <button 
                      onClick={() => {
                        const prods = siteData.productPage.products.filter((_, i) => i !== idx);
                        setSiteData({...siteData, productPage: {...siteData.productPage, products: prods}});
                      }}
                      style={css.deleteBtn}
                    >
                      <Trash2 size={16} /> Delete
                    </button>
                  )}
                </div>
                <Field label="Name (Chinese)" value={prod.name_cn} onChange={v => {
                  const prods = [...siteData.productPage.products];
                  prods[idx] = {...prods[idx], name_cn: v};
                  setSiteData({...siteData, productPage: {...siteData.productPage, products: prods}});
                }} />
                <Field label="Name (English)" value={prod.name_en} onChange={v => {
                  const prods = [...siteData.productPage.products];
                  prods[idx] = {...prods[idx], name_en: v};
                  setSiteData({...siteData, productPage: {...siteData.productPage, products: prods}});
                }} />
                <Field label="Price" value={prod.price} onChange={v => {
                  const prods = [...siteData.productPage.products];
                  prods[idx] = {...prods[idx], price: v};
                  setSiteData({...siteData, productPage: {...siteData.productPage, products: prods}});
                }} />
                
                {/* Product Image - Chinese */}
                <div style={{ background: '#fef3c7', padding: 15, borderRadius: 10, marginBottom: 15, border: '1px solid #fcd34d' }}>
                  <h5 style={{ margin: '0 0 10px', color: '#92400e' }}>🇨🇳 Image (Chinese) 图片（中文）</h5>
                  <ImageUploader
                    currentUrl={prod.image}
                    onUpload={(url) => {
                      const prods = [...siteData.productPage.products];
                      prods[idx] = {...prods[idx], image: url};
                      setSiteData({...siteData, productPage: {...siteData.productPage, products: prods}});
                    }}
                    folder="products-cn"
                    label="Chinese version image 中文版图片"
                  />
                </div>
                
                {/* Product Image - English */}
                <div style={{ background: '#dbeafe', padding: 15, borderRadius: 10, border: '1px solid #93c5fd' }}>
                  <h5 style={{ margin: '0 0 10px', color: '#1d4ed8' }}>🇬🇧 Image (English) 图片（英文）</h5>
                  <ImageUploader
                    currentUrl={prod.imageEn}
                    onUpload={(url) => {
                      const prods = [...siteData.productPage.products];
                      prods[idx] = {...prods[idx], imageEn: url};
                      setSiteData({...siteData, productPage: {...siteData.productPage, products: prods}});
                    }}
                    folder="products-en"
                    label="English version image 英文版图片"
                  />
                </div>
              </div>
            ))}
            <div style={css.card}>
              <button 
                onClick={() => {
                  const newProduct = { name_cn: '', name_en: '', price: '', image: '', imageEn: '' };
                  setSiteData({...siteData, productPage: {...siteData.productPage, products: [...siteData.productPage.products, newProduct]}});
                }}
                style={css.addBtn}
              >
                <Plus size={18} /> Add Product 添加产品
              </button>
            </div>
          </div>
        );
      case 'partners':
        return (
          <div>
            <h2 style={css.title}>Partners 伙伴</h2>
            <p style={{ color: '#666', marginBottom: 20 }}>Add up to 10 partners. Users can click to visit their URL.</p>
            
            <div style={css.card}>
              <Field label="Page Title (Chinese) 页面标题" value={siteData.partnersPage?.title_cn || ''} onChange={v => setSiteData({...siteData, partnersPage: {...siteData.partnersPage, title_cn: v}})} />
              <Field label="Page Title (English)" value={siteData.partnersPage?.title_en || ''} onChange={v => setSiteData({...siteData, partnersPage: {...siteData.partnersPage, title_en: v}})} />
              <Field label="Subtitle (Chinese) 副标题" value={siteData.partnersPage?.subtitle_cn || ''} onChange={v => setSiteData({...siteData, partnersPage: {...siteData.partnersPage, subtitle_cn: v}})} />
              <Field label="Subtitle (English)" value={siteData.partnersPage?.subtitle_en || ''} onChange={v => setSiteData({...siteData, partnersPage: {...siteData.partnersPage, subtitle_en: v}})} />
            </div>
            
            {(siteData.partnersPage?.partners || []).map((partner, idx) => (
              <div key={idx} style={{ ...css.card, background: '#fff7ed', border: '1px solid #fed7aa' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
                  <h4 style={{ margin: 0, color: '#f97316' }}>Partner {idx + 1} 伙伴 {idx + 1}</h4>
                  <button 
                    onClick={() => {
                      const partners = (siteData.partnersPage?.partners || []).filter((_, i) => i !== idx);
                      setSiteData({...siteData, partnersPage: {...siteData.partnersPage, partners}});
                    }}
                    style={css.deleteBtn}
                  >
                    <Trash2 size={16} /> Delete
                  </button>
                </div>
                <div>
                  <label style={css.label}>Name 名字</label>
                  <input 
                    value={partner.name || ''} 
                    onChange={e => {
                      const partners = [...(siteData.partnersPage?.partners || [])];
                      partners[idx] = {...partners[idx], name: e.target.value};
                      setSiteData({...siteData, partnersPage: {...siteData.partnersPage, partners}});
                    }}
                    style={css.field}
                    placeholder="Partner name"
                  />
                </div>
                <ImageUploader
                  currentUrl={partner.photo}
                  onUpload={(url) => {
                    const partners = [...(siteData.partnersPage?.partners || [])];
                    partners[idx] = {...partners[idx], photo: url};
                    setSiteData({...siteData, partnersPage: {...siteData.partnersPage, partners}});
                  }}
                  folder="partners"
                  label="Photo 照片"
                />
                <div style={{ marginTop: 15 }}>
                  <label style={css.label}>URL 链接 (TikTok, Instagram, etc.)</label>
                  <input 
                    value={partner.url || ''} 
                    onChange={e => {
                      const partners = [...(siteData.partnersPage?.partners || [])];
                      partners[idx] = {...partners[idx], url: e.target.value};
                      setSiteData({...siteData, partnersPage: {...siteData.partnersPage, partners}});
                    }}
                    style={css.field}
                    placeholder="https://www.tiktok.com/@username"
                  />
                </div>
              </div>
            ))}
            
            {(siteData.partnersPage?.partners || []).length < 10 && (
              <div style={css.card}>
                <button 
                  onClick={() => {
                    const partners = [...(siteData.partnersPage?.partners || []), { name: '', photo: '', url: '' }];
                    setSiteData({...siteData, partnersPage: {...siteData.partnersPage, partners}});
                  }}
                  style={{ ...css.addBtn, background: 'linear-gradient(135deg, #f97316, #fb923c)' }}
                >
                  <Plus size={18} /> Add Partner 添加伙伴 ({(siteData.partnersPage?.partners || []).length}/10)
                </button>
              </div>
            )}
          </div>
        );
      case 'certificates':
        return (
          <div>
            <h2 style={css.title}>Company Documents 相关文件</h2>
            {siteData.productPage.certificates.map((cert, idx) => (
              <div key={idx} style={css.card}>
                <h4 style={{ marginTop: 0 }}>Document {idx + 1}</h4>
                <Field label="Title (Chinese)" value={cert.title_cn} onChange={v => {
                  const certs = [...siteData.productPage.certificates];
                  certs[idx] = {...certs[idx], title_cn: v};
                  setSiteData({...siteData, productPage: {...siteData.productPage, certificates: certs}});
                }} />
                <Field label="Title (English)" value={cert.title_en} onChange={v => {
                  const certs = [...siteData.productPage.certificates];
                  certs[idx] = {...certs[idx], title_en: v};
                  setSiteData({...siteData, productPage: {...siteData.productPage, certificates: certs}});
                }} />
                <ImageUploader
                  currentUrl={cert.image}
                  onUpload={(url) => {
                    const certs = [...siteData.productPage.certificates];
                    certs[idx] = {...certs[idx], image: url};
                    setSiteData({...siteData, productPage: {...siteData.productPage, certificates: certs}});
                  }}
                  folder="certificates"
                  label="Document Image 文件图片"
                />
                {/* Delete Image Button */}
                {cert.image && (
                  <button 
                    onClick={() => {
                      if (window.confirm('Are you sure you want to delete this image? 确定要删除这张图片吗？')) {
                        const certs = [...siteData.productPage.certificates];
                        certs[idx] = {...certs[idx], image: ''};
                        setSiteData({...siteData, productPage: {...siteData.productPage, certificates: certs}});
                      }
                    }}
                    style={{ ...css.deleteBtn, marginTop: 10 }}
                  >
                    <Trash2 size={16} /> Delete Image 删除图片
                  </button>
                )}
              </div>
            ))}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div style={css.page}>
      {uploading && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', padding: 30, borderRadius: 16, textAlign: 'center' }}>
            <Loader size={40} style={{ animation: 'spin 1s linear infinite' }} />
            <p style={{ marginTop: 15, fontWeight: 600 }}>Uploading image... 上传中...</p>
          </div>
        </div>
      )}
      {saveStatus.show && <div style={css.toast}><CheckCircle size={18} />{saveStatus.message}</div>}
      <div style={css.sidebar}>
        <div style={{ padding: 25, borderBottom: '1px solid #eee' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 45, height: 45, background: 'linear-gradient(135deg, #9333ea, #ec4899)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700 }}>BB</div>
            <div><div style={{ fontWeight: 700 }}>BB Admin</div><div style={{ fontSize: 12, color: '#888' }}>Content Manager</div></div>
          </div>
        </div>
        <div style={{ padding: '15px 0' }}>
          {menuItems.map(item => (
            <button key={item.id} onClick={() => setActiveSection(item.id)} style={css.menuItem(activeSection === item.id)}>
              <item.icon size={20} />{item.label}
            </button>
          ))}
        </div>
        <div style={{ padding: '20px 12px', borderTop: '1px solid #eee' }}>
          <button onClick={() => { setIsLoggedIn(false); sessionStorage.removeItem('bbAdminLoggedIn'); }} style={{ ...css.menuItem(false), color: '#dc2626', justifyContent: 'center' }}><LogOut size={20} />Logout</button>
        </div>
      </div>
      <div style={css.main}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 25 }}>
          <h1 style={{ margin: 0, color: '#333' }}>Content Management</h1>
          <button onClick={saveData} style={{ ...css.btn, width: 'auto', padding: '12px 30px', display: 'flex', alignItems: 'center', gap: 8 }}><Save size={18} />Save Changes</button>
        </div>
        {renderSection()}
      </div>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default BBAdminPanel;
